import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-bsnav-bar',
	templateUrl:'./BSNavBarPage.html',
	styles: [],
	styleUrls:['./BSNavBarPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSNavBarPage
{
	mdContent_130 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.navbar.BSNavBar;
\`\`\``;
	mdContent_131 = `\`\`\`java
new BSNavBar<>()
\`\`\``;
	mdContent_132 = `\`\`\`java
new BSNavBar<>(String collapsedFieldName)
\`\`\``;
	mdContent_133 = `\`\`\`java
var navbar = new BSNavBar<>();
navbar.setNavBarTheme(BSNavBarColourSchemes.Navbar_Dark);
navbar.addBackground(BSBackgroundOptions.Bg_Dark);
navbar.setCollapseWhen(BSSizes.Large);

navbar.addBrand("My App");
navbar.addToggle();

var navs = new BSNavBarNavs<>();
navs.addItem("Home", "/home", true);
navs.addItem("About", "/about", false);
navbar.addNavs(navs);
\`\`\``;
}
